import { create } from 'zustand';

type State = {
  responsing?: boolean;
};

type Actions = {
  setResponsing: (responsing?: boolean) => void;
};

export const useResponsingStore = create<State & Actions>((set) => ({
  responsing: false,
  setResponsing: (responsing) => set({ responsing }),
}));
